import { render, staticRenderFns } from "./StockType.vue?vue&type=template&id=77d71c0e"
import script from "./StockType.vue?vue&type=script&lang=js"
export * from "./StockType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports